import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../helpers/confirm-dialog/confirm-dialog.component';

@Injectable({providedIn: 'root'})
export class BusinessErrorDialogService {
    private openMessages = new Map<string, MatDialogRef<ConfirmDialogComponent>>();

    constructor(private dialog: MatDialog) {
    }

    open(message: string): void {
        if (!message) {
            return;
        }
        if (this.openMessages.has(message)) {
            return;
        }
        const ref = this.dialog.open(ConfirmDialogComponent, {
            disableClose: false,
            data: {
                message,
                disableCancel: true,
                confirmButtonValue: 'Entendi',
                icon: 'error_outline'
            }
        });
        this.openMessages.set(message, ref);
        ref.afterClosed().subscribe(() => {
            this.openMessages.delete(message);
        });
    }
}
